module.exports = __webpack_public_path__ + "img/sacDesktop-pt-BR.03173307.png";